import axios from "axios";
import { toast } from "react-hot-toast";

export const login = async (email, password) => {
  const apiUrlLogin = `${process.env.REACT_APP_API}token`;
  const formData = new FormData();
  formData.append("username", email);
  formData.append("password", password);

  try {
    const response = await axios.post(apiUrlLogin, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    toast.success("Login successful", { position: "top-center" });
    return response.data;
  } catch (error) {
    console.error("Error en el login:", error);
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message || "Login failed"
        : "Error en la solicitud";

    toast.error(errorMessage, { position: "top-center" });
    throw error;
  }
};

export const register = async (nombre, apellido, email, password) => {
  const apiUrlRegister = `${process.env.REACT_APP_API}register`;
  const formData = new FormData();
  formData.append("first_name", nombre);
  formData.append("last_name", apellido);
  formData.append("email", email);
  formData.append("password", password);

  try {
    const response = await axios.post(apiUrlRegister, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    toast.success("Registration successful", { position: "top-center" });
    return response.data;
  } catch (error) {
    console.error("Error en el registro:", error);
    const errorMessage =
      error.response && error.response.status === 409
        ? "El correo ya existe"
        : error.response && error.response.data
          ? error.response.data.message || "Hubo un fallo en el registro"
          : "Error en la solicitud";

    toast.error(errorMessage, { position: "top-center" });
    throw error;
  }
};
